import { render, staticRenderFns } from "./MediaPostCreateView.vue?vue&type=template&id=de2f16bc&scoped=true&"
import script from "./MediaPostCreateView.vue?vue&type=script&lang=ts&"
export * from "./MediaPostCreateView.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPostCreateView.vue?vue&type=style&index=0&id=de2f16bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2f16bc",
  null
  
)

export default component.exports